module.exports = __webpack_public_path__ + "img/person-yellow.3961a80b.png";